import {
  WobaLogger,
  ConsoleTransport,
  DatadogTransport,
  ILogTransport,
} from "@woba/logger-web";

const isProduction = import.meta.env.VITE_APP_ENVIRONMENT === "production";

const transports: ILogTransport[] = [new ConsoleTransport()];

if (isProduction) {
  transports.unshift(
    new DatadogTransport({
      clientToken: import.meta.env.VITE_DATADOG_CLIENT_TOKEN || "",
      service: "web-myoffice",
      env: import.meta.env.MODE || "development",
    }),
  );
}

export const wobaLogger = new WobaLogger({
  service: "web-myoffice",
  env: import.meta.env.MODE || "development",
  version: import.meta.env.VITE_APP_VERSION || "1.0.0",
  sensitiveFields: [
    "password",
    "token",
    "cpf",
    "creditCard",
    "cvv",
    "cardNumber",
  ],
  transports,
});
